import { render } from "./gamingLaunch.vue?vue&type=template&id=2945a2f6&scoped=true"
import script from "./gamingLaunch.vue?vue&type=script&lang=js"
export * from "./gamingLaunch.vue?vue&type=script&lang=js"

import "./gamingLaunch.vue?vue&type=style&index=0&id=2945a2f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2945a2f6"]])

export default __exports__